export const APPLICATION_PDF = 'application/pdf'
